var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Author',{staticClass:"reviewed-by-wrapper",attrs:{"author":_vm.editor,"text":_vm.reviewedByString}})}
var staticRenderFns = []

export { render, staticRenderFns }